import { ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { CARD_ANIMATE_DELAY, ILandingSection, ITableRCell, ITableRow, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import TableCell from "./TableCell"
import TableTrEditor from "../../landing-edit/table/TableTrEditor"
import TableTrNull from "./TableTrNull"

export interface ITableTrProps {
    section?: ILandingSection
    threadData: ITableRow
    i:number
    row: ITableRow
    primitive: TableContent
    animated?: ANIMATED_STYLE[]
    animated_delay?: CARD_ANIMATE_DELAY | string | number
}
const TableTr = ({...props }: ITableTrProps): JSX.Element => { 
    return props.row.isHidden
        ?
        <TableTrNull {...props} />
        :
        <tr id={ props.row.id?.toString() }>
            <TableTrEditor table={ props.primitive } row={ props.threadData } i={props.i} section={ props.section || {} as ILandingSection }>
            {
                props.row.cells?.map((cell: ITableRCell, ii: number) => {
                    return <TableCell
                        key={cell.id}
                        row={ props.row }
                        cell={cell}
                        rowOrder={props.i}
                        i={props.i + ii}
                        table={props.primitive}
                        animated={props.animated}
                        animated_delay={props.animated_delay}
                        section={props.section}
                    />
                })
            }
            </TableTrEditor>
        </tr>
}

export default TableTr
